import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";


@Injectable()
export class ReportDataService {
  public mainserviceurl: string = environment.serviceURL;

  public reportSubmissionId: number;
  Language: any;
  private reportId: number;
  private cdpReportActivityList: any = null;
  private _totalPillars: number;
  private _nextPillarId: number;
  private _reportingPillarItems: any;
  private _cdpValid = true;
  private _yearChanged: boolean;
  private _selectedPillarId: number;
  private _activityItems: any;
  private _selectedPillarName: string;
  public dateRange: Object;
  constructor() {}


  public get activityItems(): any {
    return this._activityItems;
  }
  public set activityItems(v: any) {
    this._activityItems = v;
  }
  public get cdpReportActivities(): any {
    return this.cdpReportActivityList;
  }
  public set cdpReportActivities(v: any) {
    this.cdpReportActivityList = v;
  }
  public get cdpValid(): boolean {
    return this._cdpValid;
  }
  public set cdpValid(v: boolean) {
    this._cdpValid = v;
  }
  public get ReportSubmissionId(): number {
    return this.reportSubmissionId;
  }

  public set ReportSubmissionId(reportSubmissionId: number) {
    this.reportSubmissionId = reportSubmissionId;
  }
  public get nextPillarId(): number {
    return this._nextPillarId;
  }
  public set nextPillarId(v: number) {
    this._nextPillarId = v;
  }

  public get reportingPillarItems(): any {
    return this._reportingPillarItems;
  }
  public set reportingPillarItems(v: any) {
    this._reportingPillarItems = v;
  }
  public get selectedPillarId(): number {
    return this._selectedPillarId;
  }
  public set selectedPillarId(v: number) {
    this._selectedPillarId = v;
  }

  public get selectedPillarName(): string {
    return this._selectedPillarName;
  }
  public set selectedPillarName(v: string) {
    this._selectedPillarName = v;
  }
  public get totalPillars(): number {
    return this._totalPillars;
  }
  public set totalPillars(v: number) {
    this._totalPillars = v;
  }

  public get yearChanged(): boolean {
    return this._yearChanged;
  }
  public set yearChanged(v: boolean) {
    this._yearChanged = v;
  }
  public get ReportId(): number {
    return this.reportId;
  }
  public set ReportId(reportId: number) {
    this.reportId = reportId;
  }
}
